import { render, staticRenderFns } from "./NetaMultiEventDetailsMenuComponent.vue?vue&type=template&id=1865174c&scoped=true&"
import script from "./NetaMultiEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiEventDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiEventDetailsMenuComponent.vue?vue&type=style&index=0&id=1865174c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1865174c",
  null
  
)

export default component.exports